import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UcrFormsModule } from '../forms/ucrforms.module';
import { SharedModule } from '../shared/shared.module';
import { TablesModule } from '../tables/tables.module';
import { EmailCardViewComponent } from './email-card-view/email-card-view.component';
import { EmailListComponent } from './email-list/email-list.component';
import { EmailViewComponent } from './email-view/email-view.component';

@NgModule({
    declarations: [EmailCardViewComponent, EmailListComponent, EmailViewComponent],
    exports: [EmailCardViewComponent, EmailListComponent],
    imports: [CommonModule, MatCardModule, MatButtonModule, SharedModule, TablesModule, MatTooltipModule, MatIconModule, UcrFormsModule],
    providers: [DatePipe]
})
export class EmailModule {}
